import api from './api';
import { BerichtStatusTyp } from '../types';

export const berichtStatusService = {
  getAll: async (): Promise<BerichtStatusTyp[]> => {
    const response = await api.get('/bericht-status');
    return response.data;
  },

  create: async (data: { name: string; farbe: string; reihenfolge: number }): Promise<BerichtStatusTyp> => {
    const response = await api.post('/bericht-status', data);
    return response.data;
  },

  update: async (id: number, data: { name: string; farbe: string; reihenfolge: number }): Promise<BerichtStatusTyp> => {
    const response = await api.put(`/bericht-status/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/bericht-status/${id}`);
  },
};

export default berichtStatusService;
